import { render } from "./SettingsTabUserDetails.vue?vue&type=template&id=5af99e67"
import script from "./SettingsTabUserDetails.vue?vue&type=script&lang=js"
export * from "./SettingsTabUserDetails.vue?vue&type=script&lang=js"

import "./SettingsTabUserDetails.vue?vue&type=style&index=0&id=5af99e67&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__